import * as _ from 'lodash';

export class ClassMapper {
    static fromJSONArray(JSONarray: Array<Object>, classToMap, translateService = null) {
        const array = _.map(JSONarray, (a) => {
            return new classToMap(a, translateService)
        })
        return array
    }
}